import { getAnonymousUserId } from '@wegic/common/anonymous';

export function resolveAnonymousCollectUserId(anonymousUserId?: string | null): string | null {
  return anonymousUserId ?? getAnonymousUserId();
}

export function resolveInitialCollectUserId(userId: string | null | undefined): string | null {
  if (userId) {
    return userId;
  }

  return resolveAnonymousCollectUserId();
}
